var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(_vm.isShow)?_c('div',{staticClass:"poster-wrap isFixHeight",on:{"touchstart":_vm.handlerTouchstart,"touchmove":_vm.handlerTouchmove,"touchend":_vm.handlerTouchend}},[_c('img',{staticClass:"poster-image",attrs:{"src":_vm.posterUrl,"alt":""}}),_c('i',{staticClass:"close-icon"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }